import React from "react";
import { Outlet } from "react-router-dom";

/**
 * Settings shell. The side panel was removed — settings now live on a single
 * page (the profile, which also holds preferences) reached from the navbar
 * avatar menu — so this is just the auth-gated wrapper for the routed page.
 */
function SettingsLayout() {
  return (
    <div className="min-h-full">
      <Outlet />
    </div>
  );
}

export default SettingsLayout;
